import { render, staticRenderFns } from "./InvestorInformations.vue?vue&type=template&id=2b32e2b4&scoped=true&"
import script from "./InvestorInformations.vue?vue&type=script&lang=js&"
export * from "./InvestorInformations.vue?vue&type=script&lang=js&"
import style0 from "./InvestorInformations.vue?vue&type=style&index=0&id=2b32e2b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b32e2b4",
  null
  
)

export default component.exports